<template>
  <div class="vs-row full-height m-0">
    <div class="header-top clearfix">
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-2 col-sm-5 col-12 mobile-center">
            <a href="/">
              <img
                class="img-responsive"
                src="@/assets/images/logo/nowe/logo-color.svg"
                style="max-width: 190px;"
              />
            </a>
          </div>
          <div class="col-md-5"></div>
          <div class="col-md-5 col-sm-7 col-12 text-right mobile-center">
            <a href="tel:+48800706988">
              <img
                class="img-responsive"
                src="@/assets/images/logo/numer1.jpg"
                style="max-width: 210px;"
              />
              <span>800 706 988</span>
            </a>
            <vs-button
              class="login-button"
              color="#e40712"
              type="filled"
              icon="person"
              href="/login"
              style="float: right;"
              >Zaloguj</vs-button
            >
          </div>
        </div>
        <h3 class="head-banner text-center mt-5">Potwierdź e-mail</h3>
        <p class="mb-0 mt-5 text-center">
          Na twoją skrzynkę pocztową wysłaliśmy e-mail weryfikacyjny. Kliknij
          link w mailu, aby aktywować konto.
        </p>
        <vs-col class="text-center mt-5 mb-5"
          ><router-link to="/email-resend" class="reminder"
            >Nie dostałeś wiadomości? Kliknij tutaj aby wysłać ją
            ponownie.</router-link
          ></vs-col
        >
        <vs-button
          class=" btn-block btn btn-primary send-button mt-5"
          @click="$router.push('/login')"
          color="#232438"
          >Zaloguj się</vs-button
        >
        <div class="row full-width text-center mt-5">
          <div class="col-md-12">
            <img
              class="img-responsive"
              src="@/assets/images/background/logowanie-baner.png"
              style="max-width: 100%"
            />
          </div>
        </div>
        <FooterDrop></FooterDrop>
        <div class="row full-width-footer mt-5">
          <div class="col-md-3 col-12 text-right mb-5">
            <a href="#">
              <img
                class="img-responsive"
                src="@/assets/images/logo/nowe/logo-color.svg"
                style="max-width: 190px;"
              />
            </a>
          </div>
          <div class="col-md-3 col-12 text-center mb-5">
            <p class="heading-footer">BĄDŹ NA BIEŻĄCO</p>
            <a href="https://www.facebook.com/tvokazje"
              ><img
                class="img-responsive"
                src="@/assets/images/logo/facebook.png"
                style="max-width: 43px; margin-right: 15px;"
            /></a>
            <a
              href="https://www.youtube.com/channel/UCE5SDkPdH6YcISOPFDXs4-A/featured"
              ><img
                class="img-responsive"
                src="@/assets/images/logo/youtube.png"
                style="max-width: 60px; margin-right: 15px;"
            /></a>
            <a href="https://www.instagram.com/tvokazje.pl/"
              ><img
                class="img-responsive"
                src="@/assets/images/logo/instagram.png"
                style="max-width: 43px; margin-right: 15px;"
            /></a>
          </div>
          <div class="col-md-6 col-12 mb-5">
            <p class="heading-footer">CERTYFIKATY</p>
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/payu.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/mastercard.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/opineo.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/comodo-secure.png"
              style="max-width: 60px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/era.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/fedex.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/rzetelnafirma.png"
              style="max-width: 110px; margin-right: 2px;"
            />
          </div>
          <hr />
        </div>
        <div class="row full-width-footer-bottom mt-5 text-center">
          <div class="col-12">
            <p class="mt-4">
              &copy; 2020 TVO Sp. z o.o. wszelkie prawa zastrzeżone
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterDrop from "../extra-components/FooterDrop";
export default {
  name: "login-register-box",
  data: () => ({
    email: ""
  }),
  components: {
    FooterDrop
  },
  methods: {},
  computed: {},
  mounted() {
    this.email = this.$route.params.email;
  },
  destroyed() {
    this.email = "";
  }
};
</script>
<style scoped>
.reminder {
  text-align: center;
  font-size: 13px;
  color: #6b6b6b;
  cursor: pointer;
}
.reminder:hover {
  color: #f68d28;
}
.col-md-5.col-sm-7.col-12.text-right.mobile-center > a {
  display: inline-block;
  position: relative;
}
.col-md-5.col-sm-7.col-12.text-right.mobile-center > a > span {
  position: absolute;
  left: 50px;
  top: 12px;
  font-size: 18px;
  font-weight: 800;
  color: rgb(35, 36, 56);
}
.btn-block.btn.btn-danger.submit-button.mt-3 {
  background-color: #091f44;
  border-color: #091f44;
  width: 30%;
  margin-left: auto;
  margin-right: auto;
}
.vs-input--label {
  padding-left: 5px;
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.7);
}
p {
  font-size: 20px;
}
p.heading {
  font-size: 24px;
}
.full-width-footer-bottom p {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.3);
}
.collapse-header {
  font-size: 30px;
  font-weight: bold;
}
.vuesax-app-is-ltr .vs-collapse-item--icon-header {
  right: 22%;
}
i.vs-icon {
  font-size: 35px;
}
.second-collapse .vuesax-app-is-ltr .vs-collapse-item--icon-header {
  left: 0;
}
.heading-footer {
  font-size: 18px;
  font-weight: bold;
  color: #fa7b35;
}
.vs-button-warning.vs-button-filled:hover {
  box-shadow: none;
}
.login-button {
  margin-top: 2px;
  box-shadow: none;
}
.includeIcon {
  float: right;
}
.con-content--item {
  padding: 20px;
}
.blank_layout {
  overflow-x: hidden;
}
.full-height {
  background-color: white;
}
.head-banner {
  background-color: #fea03e;
  padding: 15px;
  color: white;
  max-width: 70%;
  margin-left: auto;
  margin-right: auto;
}
.text-muted {
  color: rgba(0, 0, 0, 0.7) !important;
}
.send-button {
  box-shadow: none;
  border-color: rgb(35, 36, 56);
  width: 15%;
  margin-left: auto;
  margin-right: auto;
}
@media screen and (min-width: 577px) {
  .full-height {
    background-color: white;
    display: grid;
    overflow-x: hidden;
    min-height: 100vh;
  }
}
@media screen and (max-width: 576px) {
  .row.mt-5 {
    margin-top: 0px !important;
    padding-top: 3rem;
  }
  .mobile-center {
    text-align: center !important;
  }
  .col-md-5.col-sm-8.col-12.text-right.mobile-center > a {
    display: none;
  }
  .login-button {
    margin: 18px auto 18px;
  }
  .includeIcon {
    float: initial;
  }
}
@media screen and (min-width: 1168px) {
  .full-width {
    margin-left: calc(-100vw / 2 + 1100px / 2);
    margin-right: calc(-100vw / 2 + 1100px / 2);
  }
  .full-width-footer {
    margin-left: calc(-100vw / 2 + 1140px / 2);
    margin-right: calc(-100vw / 2 + 1140px / 2);
  }
  .full-width-footer-bottom {
    margin-left: calc(-100vw / 2 + 1140px / 2);
    margin-right: calc(-100vw / 2 + 1140px / 2);
    border-top: 1px solid rgba(0, 0, 0, 0.04);
  }
}

@media screen and (max-width: 768px) {
  .row.full-width-footer.mt-5 > .col-md-3.col-12.text-right,
  .row.full-width-footer.mt-5 > .col-md-6.col-12.mb-5 {
    text-align: center !important;
  }
}
</style>
